"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetNftGroupingCategoryResponseToJSON = exports.GetNftGroupingCategoryResponseFromJSONTyped = exports.GetNftGroupingCategoryResponseFromJSON = void 0;
var _1 = require("./");
function GetNftGroupingCategoryResponseFromJSON(json) {
    return GetNftGroupingCategoryResponseFromJSONTyped(json, false);
}
exports.GetNftGroupingCategoryResponseFromJSON = GetNftGroupingCategoryResponseFromJSON;
function GetNftGroupingCategoryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nftGroupingCategories': (json['nftGroupingCategories'].map(_1.NftGroupingCategoryFromJSON)),
    };
}
exports.GetNftGroupingCategoryResponseFromJSONTyped = GetNftGroupingCategoryResponseFromJSONTyped;
function GetNftGroupingCategoryResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nftGroupingCategories': (value.nftGroupingCategories.map(_1.NftGroupingCategoryToJSON)),
    };
}
exports.GetNftGroupingCategoryResponseToJSON = GetNftGroupingCategoryResponseToJSON;
